"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _flat = _interopRequireDefault(require("flat"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Fortress = window.cccisd.fortress;
var _default = exports["default"] = function _default(json, data) {
  var formattedFields = [];
  json.fields.forEach(function (field) {
    var dataObject = data;
    var newField = field;
    if ('displayTag' in field) {
      var tag = field.displayTag;
      var matchTag = field.matchTag;
      var listPath = field.displayPath;
      var searchValue;
      if (field.from === 'user') {
        dataObject = (0, _flat["default"])(Fortress);
      }
      if (field.type === 'date') {
        searchValue = (0, _moment["default"])((0, _get2["default"])(dataObject, field.valuePath)).format(field.displaySettings.dateFormat);
      }
      if (field.type === 'string') {
        searchValue = (0, _get2["default"])(dataObject, field.valuePath);
      }
      var searchObject = (0, _get2["default"])(dataObject, listPath);
      if (!(0, _isNil2["default"])(searchValue)) {
        var match = (0, _find2["default"])(searchObject, function (item) {
          return item.devTags[matchTag] === searchValue.substr(2);
        });
        if (match) {
          newField.value = match.devTags[tag];
        }
      }
    } else {
      if (field.from === 'user') {
        dataObject = (0, _flat["default"])(Fortress);
      }
      if (field.type === 'date') {
        newField.value = (0, _moment["default"])((0, _get2["default"])(dataObject, field.valuePath)).format(field.displaySettings.dateFormat);
      }
      if (field.type === 'string') {
        newField.value = (0, _get2["default"])(dataObject, field.valuePath);
      }
    }
    formattedFields.push(newField);
  });
  return formattedFields;
};